import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';

const Component = () => {
  return (
    <Styles className='fico_scores'>
      <table>
        <thead>
          <tr>
            <th>
              <h2 className='type-h5'>Score range</h2>
            </th>
            <th>
              <h2 className='type-h5'>Rating</h2>
            </th>
            <th>
              <h2 className='type-h5'>What FICO® Scores in this range mean</h2>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p className='color-grey1'>800 or Higher</p>
            </td>
            <td>
              <p className='color-grey1'>Exceptional</p>
            </td>
            <td>
              <p className='type-h6'>
                Well above the average score of U.S. consumers
              </p>
              <p>
                Demonstrates to lenders that the consumer is an exceptional
                borrower
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p className='color-grey1'>740 to 799</p>
            </td>
            <td>
              <p className='color-grey1'>Very Good</p>
            </td>
            <td>
              <p className='type-h6'>Above the average of U.S. consumers</p>
              <p>
                Demonstrates to lenders that the consumer is a very dependable
                borrower
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p className='color-grey1'>670 to 739</p>
            </td>
            <td>
              <p className='color-grey1'>Good</p>
            </td>
            <td>
              <p className='type-h6'>
                Near or slightly above the average of U.S. consumers
              </p>
              <p>Most lenders consider this a good score</p>
            </td>
          </tr>
          <tr>
            <td>
              <p className='color-grey1'>580 to 669</p>
            </td>
            <td>
              <p className='color-grey1'>Fair</p>
            </td>
            <td>
              <p className='type-h6'>Below the average of U.S. consumers</p>
              <p>Some lenders will approve loans with this score</p>
            </td>
          </tr>
          <tr>
            <td>
              <p className='color-grey1'>Lower than 580</p>
            </td>
            <td>
              <p className='color-grey1'>Poor</p>
            </td>
            <td>
              <p className='type-h6'>
                Well below the average of U.S. consumers
              </p>
              <p>
                Demonstrates to lenders that the consumer is a risky borrower
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles>
  );
};

Component.propTypes = {};

export default Component;
